import React from 'react';
import ReactDOM from 'react-dom';
import Modal from '@bit/gerenciatd.unifiedcomponents.modal';
import '../config/styles/unifiedStyles.scss';
import { isNovum } from '@bit/gerenciatd.telcovid.common-utils';
import App from './components/AppController';
import URL_LIBRARY from '../config/pages/urlLibrary.json';
import { modules } from '../config/pages/modules';
import rootReducers from './reducers/index';
import rootSaga from './sagas/index';

const mainSetup = require('../config/mainSetup');
/*
  it seems unnecesary but regular behaviour it transform json to object,
  and we actually wants an array fas dfasdf sfasd
*/
const urlLibrary = URL_LIBRARY;
if (isNovum()) {
  if (window && window.nookInfoExchange) {
    window.nookInfoExchange.sendMessage('HeaderEnvironment', { environment: 'app' });
    window.nookInfoExchange.sendMessage('FooterEnvironment', { environment: 'app' });
  }
}

const persistConfigs = [
  {
    reducer: 'fusion',
    storage: 'session',
    filters: [
      {
        data: ['urlProdCompra'],
        action: 'persist',
        condition: true,
      },
    ],
  },
]

ReactDOM.render(
  <App
    projectId={mainSetup.projectId}
    urlLibrary={urlLibrary}
    modulesLibrary={modules}
    persistConfigs={persistConfigs}
    reduxTools={REDUXTOOLS}
    rootReducers={rootReducers}
    rootSagas={rootSaga}
    ModalComponent={Modal}
  />,
  document.getElementById(`${mainSetup.projectId}-content`),
);

// Check if hot reloading is enable. If it is, changes won't reload the page.
// This is related to webpack-dev-server and works on development only.
if (module.hot) {
  module.hot.accept();
}
